// extracted by mini-css-extract-plugin
export default {"graphCanva":"style_graphCanva__gKiQU"};